import { AdminViewType } from "../../../../shared/enums/adminViewType.enum";
import { Battery } from "../models/battery.model";
import { Company } from "../models/company.model";
import { Department } from "../models/department.model";
import { Device } from "../models/device.model";
import { Features } from "../models/features.model";
import { Forklift } from "../models/forklift.model";
import { Operator } from "../models/operator.model";
import { Organization } from "../models/organization.model";
import { ForkliftTag } from "../models/tag.model";
import { User } from "../models/user.model";

export interface adminViewInitialState {
    showFilters: boolean;
    selectedCompany: string;
    selectedView: AdminViewType;
    organizationList: Organization[];
    companyList: Company[];
    departmentList: Department[];
    deviceList: Device[];
    userList: User[];
    forkliftList: Forklift[];
    operatorList: Operator[];
    tagList: ForkliftTag[];
    batteryList: Battery[];
    featuresList: Features[];
}

const initialAdminView: adminViewInitialState = {
    showFilters: true,
    selectedCompany: "0",
    selectedView: AdminViewType.Company,
    organizationList: [],
    companyList: [],
    departmentList: [],
    deviceList: [],
    userList: [],
    forkliftList: [],
    operatorList: [],
    tagList: [],
    batteryList: [],
    featuresList: []
}

export default initialAdminView